App.addModule(function(app) {

    app.on('loaded', () => {

	    var config = window.productConfig;
	    var loaders = $('.product-view .loader');
        var reloads = $('[data-reload]');
        var options = $('.product-options dd button');
        
	    options.click(function() {

	        var option = $(this);

	        options.removeClass('active');
	        
	        option.addClass('active');
	        
		    var product_id = option.data('product-id')
		    
		    var input = $('#attribute' + option.data('attribute-id'));
		    
		    input.val(option.data('option-id'));
		    
		    loaders.show();
	        reloads.hide()
            
	        reloads.each(function() {
		        
	        	var e = $(this);
		        
			    var html = config.reload_html[product_id][e.data('reload')];

			    if (html) {
				    e.html(html);
			    }
		    });
		    
	        setTimeout(function() {
	        	loaders.hide();
		        reloads.show();
		    }.bind(this), 400);
	    });

        var hash = window.location.hash,
            found = false;
        
        if (hash) {
	        
            var params = hash.substring(1).split('&');
            
            $.each(params, function(i, item) {
	            
            	var res = item.split('=');
            	
            	if (res.length != 2) {
            		return;
            	}
            	
	            var option = $('button[data-option-id="'+ res[1] +'"]');
	            
	            if (option.length) {
	                found = true;
            	    option.click();
        	    }
	        });
        }

        if (!found) {
		    options.first().click();
	    }
    })
})
